if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      buyBoxVisibilityObserver = undefined;
      mobileMediaQuery = undefined;
      variantChangeUnsubscriber = undefined;
      isSyncingSellingPlan = false;

      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      onMobileMediaQueryChange = () => {
        this.checkDevice();
      };

      onBuyBoxVisibilityChange = () => {
        this.updateStickyVisibility();
      };

      onSkioSellingPlanUpdate = (event) => {
        if (this.isSyncingSellingPlan || !this.purchaseSelect) return;
        const picker = this.getSkioPicker();
        if (!picker || event.target !== picker) return;

        this.rebuildPurchaseSelect({ preservePlanId: true, syncFromMain: false });
        const planId = event.detail?.sellingPlan?.id;
        this.setPurchaseValue(planId != null ? String(planId) : '', { fromSkio: true });
      };

      onStickyPurchaseSelectChange = () => {
        if (this.isSyncingSellingPlan) return;
        this.setPurchaseValue(this.purchaseSelect.value, { fromSkio: false });
      };

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get variantSelect() {
        return this.querySelector(this.selectors.variantIdSelect);
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(`.main-product-form[data-product-id="${this.productId}"]`);
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.container = this.closest('.sticky-atc-bar');
        this.submitButton = this.querySelector('[type="submit"]');
        this.selectedVariantId = this.variantSelect?.value;

        this.variantData = this.getVariantData();

        this.currentVariant = this.variantData.find((v) => v.id === Number(this.selectedVariantId));
        this.updateImage(this.currentVariant);

        this.init();
        this.variantSelect?.addEventListener('change', (e) => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.refreshVariantUi(this.currentVariant);
          this.rebuildPurchaseSelect({ preservePlanId: true });
        });

        const mobileInfo = this.querySelector('.sticky-atc-bar__mobile-info');
        if (mobileInfo) {
          mobileInfo.addEventListener('click', () => {
            const target = document.querySelector('.product__info-container');
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }

        const hasRequiredFields = this.validateMainProductRequiredFields();
        if (hasRequiredFields) {
          this.submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.productFormActions.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              this.productFormActions.requestSubmit();
            }, 300);
          });
        }
      }

      disconnectedCallback() {
        this.mobileMediaQuery?.removeEventListener('change', this.onMobileMediaQueryChange);
        this.buyBoxVisibilityObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
        this.purchaseSelect?.removeEventListener('change', this.onStickyPurchaseSelectChange);
        document.removeEventListener('skio::update-selling-plan', this.onSkioSellingPlanUpdate);
        if (!document.querySelector('sticky-atc-bar')) {
          document.body.classList.remove('sticky-atc-bar-enabled');
        }
      }

      validateMainProductRequiredFields() {
        const mainForm = this.mainProductInfo;
        if (!mainForm) return true;
        const requiredFields = mainForm.querySelectorAll('[data-custom-property]');
        return requiredFields.length > 0;
      }

      updateQuantityInput() {
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(this.selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        const variantDataNode = this.container.querySelector('[data-sticky-variant-data]');
        if (!variantDataNode) return this.variantData || [];
        if (!this.variantData) {
          try {
            this.variantData = JSON.parse(variantDataNode.textContent);
          } catch {
            this.variantData = [];
          }
        }
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        this.mobileMediaQuery?.removeEventListener('change', this.onMobileMediaQueryChange);
        this.buyBoxVisibilityObserver?.disconnect();

        this.mobileMediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mobileMediaQuery.addEventListener('change', this.onMobileMediaQueryChange);
        this.checkDevice();

        this.observeTarget = this.productFormActions;
        this.buyBoxVisibilityObserver = new IntersectionObserver(this.onBuyBoxVisibilityChange, {
          threshold: 0,
        });
        this.buyBoxVisibilityObserver.observe(this.observeTarget);
        this.updateStickyVisibility();
        this.syncWithMainProductForm();
        this.initPurchaseSelectSync();
      }

      refreshVariantUi(variant) {
        if (!variant) {
          this.updateButton(true, '', true);
          return;
        }
        this.updatePrice();
        this.updateVariantInfo();
        this.updateImage(variant);
        this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
      }

      getViewportHeight() {
        return window.visualViewport?.height ?? document.documentElement.clientHeight;
      }

      updateStickyVisibility() {
        const target = this.observeTarget || this.productFormActions;
        if (!target || !this.container) return;

        const viewportHeight = this.getViewportHeight();
        const { top, bottom } = target.getBoundingClientRect();
        const buyBoxInView = top < viewportHeight && bottom > 0;
        const buyBoxBelowFold = top >= viewportHeight;
        const scrolledPastBuyBox = !buyBoxInView && !buyBoxBelowFold && top < 0;

        this.container.classList.toggle('sticky-atc-bar--show', scrolledPastBuyBox);
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.productForm;
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      updateImage(variant) {
        const img = this.querySelector('[data-sticky-product-image]');
        if (!img) return;

        const src =
          variant?.featured_image?.src ||
          variant?.featured_media?.preview_image?.src;

        if (!src) return;

        const stripSize = (s) => s.replace(/_\d+x\d*(\.[a-z]+)/i, '$1');
        const resized = (s, w) => stripSize(s).replace(/(\.[a-z]+)(\?|$)/i, `_${w}x$1$2`);

        img.src = resized(src, 180);
        img.srcset = `${resized(src, 90)} 90w, ${resized(src, 180)} 180w`;
      }

      updateVariantInfo() {
        if (!this.currentVariant) return;
        const titleEl = this.querySelector('[data-sticky-variant-title]');
        const priceEl = this.querySelector('[data-sticky-variant-price]');
        if (titleEl) titleEl.textContent = this.currentVariant.title;
        if (priceEl) priceEl.textContent = FoxTheme.Currency.formatMoney(this.currentVariant.price, FoxTheme.settings.moneyFormat).replace('$ ', '$');
      }

      syncWithMainProductForm() {
        this.variantChangeUnsubscriber?.();
        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const mainSectionId = this.mainProductInfo?.dataset?.section;
          if (!mainSectionId || event.data.sectionId !== mainSectionId) return;
          const variant = event.data.variant;

          // Skip if this variant is hidden (its ID won't appear in the select options).
          if (!variant || !this.variantSelect || !Array.from(this.variantSelect.options).some((opt) => Number(opt.value) === variant.id)) return;

          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.refreshVariantUi(variant);
          this.updateQuantityInput();
          this.rebuildPurchaseSelect({ preservePlanId: true });
        });
      }

      getSkioPicker() {
        return (
          this.mainProductInfo?.querySelector('skio-plan-picker') ||
          document.querySelector(`product-info[data-product-id="${this.productId}"] skio-plan-picker`)
        );
      }

      getPurchaseOptions() {
        const picker = this.getSkioPicker();
        const variant = this.currentVariant;
        if (!picker?.getPurchaseOptionsForVariant || !variant) {
          return { requiresSellingPlan: false, onetimeTitle: '', plans: [] };
        }
        return picker.getPurchaseOptionsForVariant(variant);
      }

      initPurchaseSelectSync() {
        this.purchaseSelect = this.querySelector('[data-sticky-purchase-select]');
        this.purchaseWrapper = this.querySelector('[data-sticky-purchase-wrapper]');
        this.sellingPlanInput = this.querySelector('[data-sticky-selling-plan-input]');
        if (!this.purchaseSelect) return;

        if (!this.getSkioPicker()) {
          if (this.purchaseWrapper) this.purchaseWrapper.hidden = true;
          return;
        }

        this.purchaseSelect.removeEventListener('change', this.onStickyPurchaseSelectChange);
        this.purchaseSelect.addEventListener('change', this.onStickyPurchaseSelectChange);
        document.removeEventListener('skio::update-selling-plan', this.onSkioSellingPlanUpdate);
        document.addEventListener('skio::update-selling-plan', this.onSkioSellingPlanUpdate);
        requestAnimationFrame(() => {
          this.rebuildPurchaseSelect({ preservePlanId: true });
          this.syncPurchaseFromMain();
        });
      }

      rebuildPurchaseSelect({ preservePlanId = false, syncFromMain = true } = {}) {
        const picker = this.getSkioPicker();
        if (!this.purchaseSelect || !picker) return;

        const { plans, onetimeTitle, requiresSellingPlan } = this.getPurchaseOptions();
        const prevValue = preservePlanId ? this.purchaseSelect.value : '';
        const prevLabel = prevValue
          ? this.purchaseSelect.querySelector(`option[value="${CSS.escape(prevValue)}"]`)?.textContent
          : '';
        const fragment = document.createDocumentFragment();

        if (!requiresSellingPlan) {
          const otp = document.createElement('option');
          otp.value = '';
          otp.dataset.purchaseMode = 'onetime';
          otp.textContent = onetimeTitle;
          fragment.appendChild(otp);
        }

        for (const plan of plans) {
          const option = document.createElement('option');
          option.value = String(plan.id);
          option.textContent = plan.name;
          fragment.appendChild(option);
        }

        this.purchaseSelect.replaceChildren(fragment);

        if (this.purchaseWrapper) {
          this.purchaseWrapper.hidden = !plans.length && requiresSellingPlan;
        }

        let next = '';
        if (preservePlanId && prevValue === '') next = '';
        else if (preservePlanId && prevValue && plans.some((p) => String(p.id) === prevValue)) next = prevValue;
        else if (preservePlanId && prevLabel) {
          const match = plans.find((p) => p.name === prevLabel);
          if (match) next = String(match.id);
        }

        this.purchaseSelect.value = next;
        if (this.sellingPlanInput) this.sellingPlanInput.value = next;
        this.checkDevice();

        if (syncFromMain) requestAnimationFrame(() => this.syncPurchaseFromMain());
      }

      setPurchaseValue(value, { fromSkio = false } = {}) {
        if (!this.purchaseSelect) return;

        if (value !== '' && !this.purchaseSelect.querySelector(`option[value="${CSS.escape(value)}"]`)) {
          value = '';
        }

        this.purchaseSelect.value = value;
        if (this.sellingPlanInput) this.sellingPlanInput.value = value;
        if (!fromSkio) this.pushPurchaseToSkio(value);
        this.checkDevice();
      }

      pushPurchaseToSkio(planId) {
        const picker = this.getSkioPicker();
        if (!picker) return;

        this.isSyncingSellingPlan = true;
        if (planId) picker.selectSellingPlan(Number(planId));
        else picker.selectSellingPlanGroup(null);
        requestAnimationFrame(() => {
          this.isSyncingSellingPlan = false;
        });
      }

      syncPurchaseFromMain() {
        const formId = this.productFormActions?.id;
        if (!formId) return;

        const mainInput = document.querySelector(`input[name="selling_plan"][form="${CSS.escape(formId)}"]`);
        const picker = this.getSkioPicker();
        const planId = mainInput?.value ?? (picker?.selectedSellingPlan?.id != null ? String(picker.selectedSellingPlan.id) : '');

        this.setPurchaseValue(planId, { fromSkio: true });
      }
    }
  );
}
